import type { AccessUser, PropertyReportSubscriptionAttributes } from 'common'

import { coreClient } from '@/api/coreclient'

export default {
  async list(admin?: boolean) {
    const client = await coreClient()
    return client.propertyReport
      .list(admin)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as PropertyReportSubscriptionAttributes[]
      })
  },
  async getReport(id?: number, publicId?: string, options?: { logVisit?: boolean }) {
    const client = await coreClient()
    return client.propertyReport.getReport(id, publicId, options?.logVisit).then((response) => {
      return response.data
    })
  },
  async update(body: PropertyReportSubscriptionAttributes) {
    const client = await coreClient()
    return client.propertyReport
      .update(body)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async delete(id: number) {
    const client = await coreClient()
    return client.propertyReport.delete(id).then((response) => {
      return response.data
    })
  },
  async sendEmail(id: number) {
    const client = await coreClient()
    return client.propertyReport
      .sendEmail(id)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async getAccess(reportId: number) {
    const client = await coreClient()
    return client.propertyReport
      .getAccess(reportId)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as AccessUser[]
      })
  },
  async createAccess(
    reportId: number,
    notify: boolean,
    data: { email: string; user_id: string | null; read_only?: boolean }[]
  ) {
    const client = await coreClient()
    return client.propertyReport
      .createAccess(reportId, notify, data)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as AccessUser[]
      })
  },
  async updateAccess(reportId: number, userId: string, readOnly: boolean) {
    const client = await coreClient()
    return client.propertyReport
      .updateAccess(reportId, userId, { read_only: readOnly })
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async deleteAccess(reportId: number, userId: string) {
    const client = await coreClient()
    return client.propertyReport
      .deleteAccess(reportId, userId)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
